import CacheableDataObject from "./CacheableDataObject.jsx";
import PlaidBankAccount from "./PlaidBankAccount.js";
import { colorFromName } from "../utilities/accountIcons.js";


/**
 * An institution: the budget's linked_plaid_accounts row and the accounts grouped under it.
 * `institution` is the shared plaid_institutions row, only ever a source of a logo or a colour.
 */
export default class PlaidAccount extends CacheableDataObject {
	/** What the budget calls the institution. */
	getName() {
		return this.institution_name || this.institution?.name || '';
	}

	/** The colour the budget chose, else Plaid's, else one made from the name. Its accounts are drawn in it. */
	getColor() {
		return this.color || this.institution?.primary_color || colorFromName(this.getName());
	}

	getTotalBalance(selectedDate, useSelectedDateByDay = false) {
		if(!selectedDate) {
			return this.getTotalLatestBalance();
		}

		let addedSome = false;
		let totalBalance = 0;
		for(let account of this.accounts) {
			if(!account.shouldAddToTotalAssets()) {
				console.log('skipping account', account);
				continue;
			}
			const balance = account.getLatestBalanceForMonth(selectedDate, useSelectedDateByDay);
			if(!balance) {
				continue;
			}
			addedSome = true;
			totalBalance += balance.getRelativeBalanceAmount();
		}
		return addedSome ? totalBalance : null;
	}

	getTotalLatestBalance() {
		let totalBalance = 0;
		for(let account of this.accounts) {
			const balance = account.getLatestBalance();
			if(!balance) {
				continue;
			}
			totalBalance += balance.getRelativeBalanceAmount();
		}
		return totalBalance;
	}
}

PlaidAccount.prototype.dataLocationParsers = {
	accounts: (plaidAccount, data) => {
		plaidAccount.accounts = [];
		for(let account of data.accounts) {
			plaidAccount.accounts.push(PlaidBankAccount.retrieve(account));
		}
	},
};

